import { makeStyles } from '@material-ui/core';

export default makeStyles(({ spacing, palette }: any) => ({
  container: {
    backgroundColor: palette.primary.main,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  containerWithLogo: {
    height: spacing(12.5),
  },
  faqOnly: {
    justifyContent: 'flex-end',
  },
  centerLogo: {
    display: 'flex',
    position: 'absolute',
    left: '50%',
    transform: 'translate(-50%)',
  },
  faqButton: {
    color: palette.common.white,
    padding: `${spacing(2.5)}px ${spacing(5)}px ${spacing(2.5)}px ${spacing(5)}px`,
  },
  leftComponent: {
    height: '100%',
    padding: `0 0 0 ${spacing(4)}px`,
    boxSizing: 'content-box',
    display: 'flex',
    alignItems: 'center',
  },
  leftTextButton: {
    paddingBottom: 0,
    marginBottom: spacing(0.5),
    height: '22px',
    '& .MuiButton-label': {
      color: palette.common.white,
    },
    borderBottom: `2px solid ${palette.common.white}`,
  },
  categoryNameContainer: {
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  arrows: {
    width: spacing(2.5),
    display: 'flex',
    flexDirection: 'column',
    marginLeft: spacing(2.5),
  },
  upArrow: {
    marginBottom: spacing(1),
    stroke: palette.common.white,
  },
  downArrow: {
    stroke: palette.common.white,
  },
}));
